module.exports = __webpack_public_path__ + "static/media/paper.2d3b41e2.svg";